import React from 'react';
import theme from './BuyerChangeRequestOfferGroupList.module.scss';
import { ChangeRequestProgressInfoOfferGroup } from '@/types';
import BuyerChangeRequestOfferGroup from './BuyerChangeRequestOfferGroup';

interface BuyerChangeRequestOfferGroupListProps {
    groups: ChangeRequestProgressInfoOfferGroup[];
    isPreview?: boolean;
}

const BuyerChangeRequestOfferGroupList: React.FC<BuyerChangeRequestOfferGroupListProps> = ({ groups, ...rest }) => {
    if (!groups || groups.length === 0) {
        return null;
    }

    return (
        <ul className={theme.list}>
            {groups.map((x, index) => (
                <li key={index}>
                    <BuyerChangeRequestOfferGroup group={x} {...rest} />
                </li>
            ))}
        </ul>
    );
};

export default BuyerChangeRequestOfferGroupList;
